import * as Sentry from "@sentry/react";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  AppErrorFallback,
  RootErrorComponent,
} from "./components/app-error-fallback";
import { ThemeProvider } from "./components/theme-provider";
import { initCapacitor } from "./lib/capacitor";
import { installStaleDeployReload } from "./lib/reload-on-stale-deploy";
import { initSentry } from "./lib/sentry";
import { routeTree } from "./routeTree.gen";
import "./index.css";

initSentry();
initCapacitor();
installStaleDeployReload();

const router = createRouter({
  routeTree,
  defaultErrorComponent: RootErrorComponent,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");
createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
